module.exports = __webpack_public_path__ + "img/qishi2@2x.37109bd8.png";